import { Point } from '@angular/cdk/drag-drop/typings/drag-ref';
import { AfterViewInit, Component, ElementRef, HostBinding, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { CurrentService } from 'dbweb-core';
import { PortraitMaskComponent } from './portrait-mask/portrait-mask.component';
import { portraitDefault } from '../../const';

export interface PortraitEditComponentData {
	img: HTMLImageElement;
	default: boolean;
}
export interface PortraitEditComponentResultData {
	ok: boolean;
	data: string;
}
const ImageMaxWidth = 224;
const ImageMaxHeight = 224;
const PortraitSize = 224; // 112;
@Component({
	selector: 'common-portrait-edit',
	templateUrl: './portrait-edit.component.html',
	styleUrls: ['./portrait-edit.component.scss']
})
export class PortraitEditComponent implements OnInit, AfterViewInit {
	@HostBinding('class.portrait-edit') hostClass = true;
	@ViewChild('portraitImage', { static: true }) portraitImage: ElementRef<HTMLImageElement>;
	@ViewChild('srcImage', { static: true }) srcImage: ElementRef<HTMLImageElement>;
	@ViewChild('dragContainer', { static: true }) dragContainer: ElementRef<HTMLElement>;
	@ViewChild('preview', { static: true }) preview: ElementRef<HTMLCanvasElement>;
	@ViewChild('mask', { static: true }) mask: PortraitMaskComponent;
	dragStartPoint: Point;
	dragStartTransformPosition: Point;
	dragStartImageRound: ClientRect;
	realImageWidth: number;
	realImageHeight: number;
	zoomFactor: number;
	minZoomFactor: number;
	maskRect: ClientRect;
	translateX = 0;
	translateY = 0;
	rotateScope = 0;
	modified = false;
	afterInit = false;
	default = false; // æ¯å¦æ¯ç¼ºççå¾çï¼ç¼ºçå¾çä¸éè¦ä¿å­
	constructor(
		public dialogRef: MatDialogRef<PortraitEditComponent>,
		@Inject(MAT_DIALOG_DATA) public data: PortraitEditComponentData,
		private _sanitizer: DomSanitizer,
		public curr: CurrentService
	) {}
	ngAfterViewInit() {
		this.srcImage.nativeElement.onload = () => {
			this.realImageWidth = this.srcImage.nativeElement.width;
			this.realImageHeight = this.srcImage.nativeElement.height;
			let w = this.srcImage.nativeElement.width;
			let h = this.srcImage.nativeElement.height;
			this.minZoomFactor = this.zoomFactor = 1;
			if (w < h && h > ImageMaxHeight) {
				this.minZoomFactor = this.zoomFactor = ImageMaxHeight / h;
				w = w * this.zoomFactor;
				h = ImageMaxHeight;
			} else if (w > h && w > ImageMaxHeight) {
				this.minZoomFactor = this.zoomFactor = ImageMaxWidth / w;
				h = h * this.zoomFactor;
				w = ImageMaxWidth;
			}
			this.portraitImage.nativeElement.width = w;
			this.portraitImage.nativeElement.height = h;
			this.translateX = Math.round((ImageMaxWidth - w) / 2);
			this.translateY = Math.round((ImageMaxHeight - h) / 2);

			this.rebuildImage();
		};
		this.srcImage.nativeElement.src = this.data.img.src;
		this.default = this.data.default;
		this.afterInit = true;
	}
	ngOnInit() {}
	rebuildImage() {
		const c = document.createElement('canvas');
		if (this.rotateScope === 0 || this.rotateScope === 0.5) {
			c.width = this.srcImage.nativeElement.width;
			c.height = this.srcImage.nativeElement.height;
		} else {
			c.width = this.srcImage.nativeElement.height;
			c.height = this.srcImage.nativeElement.width;
		}

		const ctx = c.getContext('2d');
		ctx.clearRect(0, 0, c.width, c.height);
		// move to the center of the canvas
		ctx.translate(c.width / 2, c.height / 2);

		// rotate the canvas to the specified degrees
		ctx.rotate(this.rotateScope * 2 * Math.PI);

		// draw the image
		// since the context is rotated, the image will be rotated also
		ctx.drawImage(
			this.srcImage.nativeElement,
			-this.srcImage.nativeElement.width / 2,
			-this.srcImage.nativeElement.height / 2
		);

		this.portraitImage.nativeElement.src = c.toDataURL();

		setTimeout(() => {
			this.drawPreview();
		}, 150);
	}
	pimgLoad() {
		const offset = this.correctionOffset(
			(this.portraitImage.nativeElement.width - this.realImageWidth * this.zoomFactor) / 2,
			(this.portraitImage.nativeElement.height - this.realImageHeight * this.zoomFactor) / 2,
			this.portraitImage.nativeElement.getBoundingClientRect()
		);
		this.translateX += offset.x;
		this.translateY += offset.y;
	}

	startDragImage(event: MouseEvent) {
		this.dragStartPoint = { x: event.x, y: event.y };
		this.dragStartTransformPosition = { x: this.translateX, y: this.translateY };

		this.dragStartImageRound = this.portraitImage.nativeElement.getBoundingClientRect();
	}
	// ç»å®ä¸ä¸ªåç§»ï¼è¿åæ ¡æ­£çç»æ
	correctionOffset(dx: number, dy: number, imageRect: ClientRect): Point {
		const containerRect = this.dragContainer.nativeElement.getBoundingClientRect();
		let lx: number, hx: number, ly: number, hy: number;
		// å¦æå¾çå®½åº¦å°äºå®¹å¨ï¼åæ¯å·¦è¾¹æ¡å·¦ç§»ä¸è½è¿å®¹å¨å·¦è¾¹æ¡
		if (containerRect.width > imageRect.width) {
			lx = containerRect.left - imageRect.left;
			hx = containerRect.right - imageRect.right;
		} else {
			// å¦åæ¯å³è¾¹æ¡å·¦ç§»ä¸è½ç¦»å¼å®¹å¨å³è¾¹æ¡
			lx = containerRect.right - imageRect.right;
			hx = containerRect.left - imageRect.left;
		}
		if (containerRect.height > imageRect.height) {
			ly = containerRect.top - imageRect.top;
			hy = containerRect.bottom - imageRect.bottom;
		} else {
			ly = containerRect.bottom - imageRect.bottom;
			hy = containerRect.top - imageRect.top;
		}
		return { x: Math.max(lx, Math.min(hx, dx)), y: Math.max(ly, Math.min(hy, dy)) };
	}
	draggingImage(event: Point) {
		const offset = this.correctionOffset(
			event.x - this.dragStartPoint.x,
			event.y - this.dragStartPoint.y,
			this.dragStartImageRound
		);
		this.translateX = this.dragStartTransformPosition.x + offset.x;
		this.translateY = this.dragStartTransformPosition.y + offset.y;
		this.drawPreview();
		this.modified = true;
		this.default = false;
	}
	zoomIn(event: MouseEvent) {
		// æ¾å¤§10%
		this.zoomFactor = Math.min(1, this.zoomFactor * 1.1);
		if (this.rotateScope === 0 || this.rotateScope === 0.5) {
			this.portraitImage.nativeElement.width = this.realImageWidth * this.zoomFactor;
			this.portraitImage.nativeElement.height = this.realImageHeight * this.zoomFactor;
		} else {
			this.portraitImage.nativeElement.width = this.realImageHeight * this.zoomFactor;
			this.portraitImage.nativeElement.height = this.realImageWidth * this.zoomFactor;
		}
		const offset = this.correctionOffset(
			-(this.realImageWidth * this.zoomFactor - this.portraitImage.nativeElement.width) / 2,
			-(this.realImageHeight * this.zoomFactor - this.portraitImage.nativeElement.height) / 2,
			this.portraitImage.nativeElement.getBoundingClientRect()
		);
		this.translateX += offset.x;
		this.translateY += offset.y;
		this.modified = true;
		this.default = false;

		this.drawPreview();
	}
	zoomOut(event: MouseEvent) {
		// ç¼©å°10%
		this.zoomFactor = Math.max(this.minZoomFactor, this.zoomFactor * 0.9);

		if (this.rotateScope === 0 || this.rotateScope === 0.5) {
			this.portraitImage.nativeElement.width = this.realImageWidth * this.zoomFactor;
			this.portraitImage.nativeElement.height = this.realImageHeight * this.zoomFactor;
		} else {
			this.portraitImage.nativeElement.width = this.realImageHeight * this.zoomFactor;
			this.portraitImage.nativeElement.height = this.realImageWidth * this.zoomFactor;
		}

		const offset = this.correctionOffset(
			(this.portraitImage.nativeElement.width - this.realImageWidth * this.zoomFactor) / 2,
			(this.portraitImage.nativeElement.height - this.realImageHeight * this.zoomFactor) / 2,
			this.portraitImage.nativeElement.getBoundingClientRect()
		);
		this.translateX += offset.x;
		this.translateY += offset.y;
		this.modified = true;
		this.default = false;

		this.drawPreview();
	}

	drawPreview() {
		const imageRect = this.portraitImage.nativeElement.getBoundingClientRect();
		// äº¤é
		const r = {
			left: Math.max(imageRect.left, this.maskRect.left),
			top: Math.max(imageRect.top, this.maskRect.top),
			right: Math.min(imageRect.right, this.maskRect.right),
			bottom: Math.min(imageRect.bottom, this.maskRect.bottom)
		};
		// ç¸å¯¹å¾çå·¦ä¸è§çåç§»
		r.left = r.left - imageRect.left;
		r.top = r.top - imageRect.top;
		r.right = r.right - imageRect.left;
		r.bottom = r.bottom - imageRect.top;
		const drawX = this.maskRect.left < imageRect.left ? (imageRect.left - this.maskRect.left) / this.zoomFactor : 0;
		const drawY = this.maskRect.top < imageRect.top ? (imageRect.top - this.maskRect.top) / this.zoomFactor : 0;

		const realWidth = ((r.right - r.left) / this.maskRect.width) * PortraitSize;
		const realHeight = ((r.bottom - r.top) / this.maskRect.height) * PortraitSize;
		// åç¼©æ¾å°å®éå¾çä¸­
		r.left /= this.zoomFactor;
		r.top /= this.zoomFactor;
		r.right /= this.zoomFactor;
		r.bottom /= this.zoomFactor;
		const ctx = this.preview.nativeElement.getContext('2d');

		if (realWidth < PortraitSize || realHeight < PortraitSize) {
			ctx.fillStyle = 'white';
			ctx.fillRect(0, 0, this.preview.nativeElement.width, this.preview.nativeElement.height);
		}
		ctx.save();
		const sc = PortraitSize / (this.maskRect.width / this.zoomFactor);
		ctx.scale(sc, sc);
		ctx.drawImage(
			this.portraitImage.nativeElement,
			r.left,
			r.top,
			r.right - r.left,
			r.bottom - r.top,
			drawX,
			drawY,
			r.right - r.left,
			r.bottom - r.top
		);
		ctx.restore();
	}
	maskChange(rect: ClientRect) {
		this.maskRect = rect;
		// å ä¸ºæå¼å§å°±ä¼è§¦åä¸æ¬¡ï¼éè¦åå§åè¿åæç¿»è½¬ç¶æ
		if (this.afterInit) {
			this.default = false;

			this.modified = true;
		}
		this.drawPreview();
	}
	rotate(event: MouseEvent) {
		if (this.rotateScope === 0) {
			this.rotateScope = 0.75;
		} else {
			this.rotateScope -= 0.25;
		}
		const tmp = this.portraitImage.nativeElement.width;
		this.portraitImage.nativeElement.width = this.portraitImage.nativeElement.height;
		this.portraitImage.nativeElement.height = tmp;
		this.modified = true;
		this.default = false;

		this.rebuildImage();
	}

	get imageStyle(): SafeStyle {
		return this._sanitizer.bypassSecurityTrustStyle(
			'translate(' + this.translateX + 'px, ' + this.translateY + 'px)'
		);
	}
	fileChange(event: FileList) {
		const reader = new FileReader();
		const self = this;
		reader.onload = function(oFREvent: any) {
			self.srcImage.nativeElement.src = oFREvent.target.result as string;
		};
		this.modified = true;
		this.default = false;

		reader.readAsDataURL(event[0]);
	}
	ok() {
		this.dialogRef.close({
			ok: true,
			data: this.default ? null : this.preview.nativeElement.toDataURL('image/jpeg')
		} as PortraitEditComponentResultData);
	}
	restoreDefault() {
		this.modified = true;
		this.mask.reset();
		this.srcImage.nativeElement.src = portraitDefault;
		this.default = true;
	}
}
